// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1nu9b","disabled":"FileBtn_disabled__M_Soy","warn":"FileBtn_warn__1MvWX","fade":"FileBtn_fade__2FzLg"};